import React, { useEffect } from "react";
import MKBox from "components/MKBox";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography";

function Direction() {
  // 네이버 지도 API 초기화
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://oapi.map.naver.com/openapi/v3/maps.js?ncpClientId=9xaa7nirka";
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      if (window.naver) {
        const mapContainer = document.getElementById("map"); // 지도를 표시할 div
        const mapOptions = {
          center: new window.naver.maps.LatLng(36.3641082, 127.4042811), // 초기 지도 중심 좌표
          zoom: 16, // 초기 줌 레벨
        };

        // 지도 생성
        const map = new window.naver.maps.Map(mapContainer, mapOptions);

        // 마커 생성
        const marker = new window.naver.maps.Marker({
          position: new window.naver.maps.LatLng(36.3641082, 127.4042811),
          map: map,
        });

        // 마커에 인포윈도우 추가 (선택 사항)
        const infoWindow = new window.naver.maps.InfoWindow({
          content: '<div style="padding:5px;">대덕구 대화로 284-3(좋은빛)</div>',
        });
        infoWindow.open(map, marker);
      }
    };

    return () => {
      // 클린업: 스크립트 제거
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{
            textAlign: "center",
            my: { xs: 4, sm: 6, md: 6 }, // 반응형 마진
            mx: "auto",
            px: { xs: 0.5, sm: 0.75, md: 1 }, // 반응형 패딩
          }}
        >
          <MKTypography
            variant="h2"
            fontWeight="bold"
            sx={{
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" }, // 반응형 폰트 크기
            }}
          >
            오시는 길
          </MKTypography>
          <MKTypography
            variant="body4"
            sx={{
              fontSize: { xs: "0.7rem", sm: "1rem", md: "1.5rem" }, // 반응형 폰트 크기
            }}
          >
            대전광역시 대덕구 대화로 284-3 번지
          </MKTypography>
        </Grid>
      </Container>
      <MKBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height={{ xs: "35vh", sm: "70vh", md: "100vh" }} // 반응형 높이 설정
        position="relative" // 자식 요소의 절대 위치 지정 가능
        paddingBottom="30px"
      >
        {/* 네이버 지도 */}
        <div
          id="map"
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </MKBox>
    </>
  );
}

export default Direction;
